import { combineReducers } from 'redux-immutable'
import { reducer as formReducer } from 'redux-form/immutable'
import settings from './settings/reducer'
import auth from './auth/reducer'
import profile from './profile/reducer'
import dashboard from './dashboard/reducer'
import locale from './locale/reducer'
import user from './user/reducer'
import licensee from './licensee/reducer'
import site from './site/reducer'
import locus from './locus/reducer'
import notice from './notice'
import mortality from './mortality/reducer'
import satellite from './satellite/reducer'
import loader from './loader/reducer'
import audit from './audit/reducer'
import digitalLogbook from './digitalLogbook/reducer'
import view from './view/reducer'
import entry from './entry/reducer'
import layout from './layout/reducer'
import dashboardGrowth from './dashboard/growth/reducer'
import slaMonitor from './slaMonitor/reducer'
import seaLice from './seaLice/reducer'
import logbook from './logbook/reducer'
import logbookForm from './logbookForm/reducer'
import environmentMonitor from './environmentMonitor/reducer'
import sisense from './sisense/reducer'
import environment from './slaMonitor/environment/reducer'
import feedback from './feedback/reducer'
import sensor from './sensor/reducer'
import monitorsAndAlerts from './monitorsAndAlerts/reducer'
import dataBrowser from './dataBrowser/reducer'
import locusGroup from './locusGroup/reducer'
import files from './common/files/reducer'
import userGroup from './userGroup/reducer'
import siteGroup from './siteGroup/reducer'
import application from './application/reducer'
import licenseeApplication from './licenseeApplication/reducer'
import myJobs from './myJobs/reducer'
import myJobsDataViewer from './myJobsDataViewer/reducer'
import jobWorkflow from './jobsWorkflowAdminJob/reducer'
import jobWorkflowTranslations from './translations/jobWorkflow/reducer'
import jobWorkflowTaskTranslations from './translations/jobWorkflowTask/reducer'
import jobWorkflowInputTranslations from './translations/jobWorkflowInput/reducer'
import logbookEventTranslations from './translations/logbookEvent/reducer'
import logbookEventCategoryTranslations from './translations/logbookEventCategory/reducer'
import logbookFormTranslations from './translations/logbookForm/reducer'
import monitoringAlertsTranslations from './translations/monitoringAlerts/reducer'
import sensorTypeTranslations from './translations/sensorType/reducer'
import jobTasksAdmin from './jobTasksAdmin/reducer'
import jobInputsAdmin from './jobInputsAdmin/reducer'
import jobInputGroupsAdmin from './jobInputGroupsAdmin/reducer'
import jobInputItemsAdmin from './jobInputItemsAdmin/reducer'
import projectedSitesManager from './projectedSitesManager/reducer'
import lookupTables from './lookupTables/reducer'
import jobsTriggers from './jobsTriggers/reducer'
import featureFlags from './featureFlags/reducer'
import managementUI from './managementUI/reducer'
import pdfReports from './pdfReports/reducer'
import maintenance from './maintenance/reducer'

export default combineReducers({
  settings,
  locale,
  auth,
  layout,
  profile,
  dashboard,
  user,
  licensee,
  site,
  locus,
  notice,
  mortality,
  satellite,
  loader,
  audit,
  digitalLogbook,
  view,
  entry,
  dashboardGrowth,
  slaMonitor,
  environment,
  seaLice,
  environmentMonitor,
  form: formReducer,
  logbook,
  logbookForm,
  feedback,
  sensor,
  sisense,
  monitorsAndAlerts,
  dataBrowser,
  locusGroup,
  files,
  userGroup,
  siteGroup,
  application,
  licenseeApplication,
  myJobs,
  jobWorkflowTranslations,
  jobWorkflowTaskTranslations,
  jobWorkflowInputTranslations,
  logbookEventTranslations,
  logbookEventCategoryTranslations,
  logbookFormTranslations,
  monitoringAlertsTranslations,
  sensorTypeTranslations,
  myJobsDataViewer,
  jobInputsAdmin,
  jobInputGroupsAdmin,
  jobInputItemsAdmin,
  jobTasksAdmin,
  jobWorkflow,
  projectedSitesManager,
  managementUI,
  lookupTables,
  jobsTriggers,
  featureFlags,
  pdfReports,
  maintenance,
})
